<template>
  <v-avatar :size="size">
    <v-img
      v-if="loadImg"
      :src="imgSrc(resource.photo, imgSize)"
      aspect-ratio="1"
      :class="color"
      @error="loadImg = false"
    >
      <template #placeholder>
        <v-row
          class="fill-height ma-0"
          align="center"
          justify="center"
        >
          <v-progress-circular
            indeterminate
            :size="loadingSize"
            :color="loadingColor"
            width="2"
          />
        </v-row>
      </template>
    </v-img>
    <v-row
      v-else
      class="fill-height"
      :class="color"
      align="center"
      justify="center"
    >
      {{ resource.name | initials }}
    </v-row>
  </v-avatar>
</template>

<script>
  import RequestsCloudImages from '@/Mixins/RequestsCloudImages'

  export default {
    mixins: [
      RequestsCloudImages,
    ],

    props: {
      resource: {
        required: true,
        type: Object,
      },
      size: {
        type: [Number, String],
        required: false,
        default: 48,
      },
      color: {
        required: false,
        type: String,
        default: 'grey lighten-2',
      },
      loadingColor: {
        required: false,
        type: String,
        default: 'grey lighten-3',
      },
      imgSize: {
        type: [Number, String],
        required: false,
        default: 100,
      },
    },

    data: () => ({
      loadImg: undefined,
    }),

    created () {
      this.loadImg = Boolean(this.resource.photo)
    },

    computed: {
      loadingSize () {
        return Math.round(this.size * .75)
      },
    },

    filters: {
      initials: v => v
        .toUpperCase()
        .split(/[\s,-]+/)
        .filter(word => word.length > 2 && ['CON', 'AND'].indexOf(word) === -1)
        .slice(0, 3)
        .map(word => word[0])
        .join('')
      ,
    },
  }
</script>
